export default __webpack_public_path__ + "static/media/PEFI.d20bf8df.png";